import PropTypes from 'prop-types';

import CustomSVGIcon from './CustomSVGIcon';

const Sum = ({ color = '', ...other }) => {
	return (
		<CustomSVGIcon {...other}>
			<g id="sum" transform="translate(-1131.000000, -402.000000)" fill={color} fillRule="nonzero">
				<path d="M1142.24993,417 L1131.75039,417 C1131.4594,417 1131.19464,416.831223 1131.07091,416.567964 C1130.94718,416.304705 1130.98769,415.993518 1131.17431,415.769947 L1136.39868,409.499931 L1131.17431,403.23074 C1130.98769,403.006482 1130.94787,402.695295 1131.07091,402.432036 C1131.19464,402.168777 1131.4594,402 1131.75039,402 L1142.24993,402 C1142.66397,402 1143,402.335219 1143,402.749952 L1143,404.999945 C1143,405.414678 1142.66397,405.750034 1142.24993,405.750034 C1141.83604,405.750034 1141.5,405.414678 1141.5,404.999945 L1141.5,403.500041 L1133.35159,403.500041 L1137.95113,409.019281 C1138.18294,409.297509 1138.18294,409.701667 1137.95113,409.980032 L1133.35159,415.499959 L1141.5,415.499959 L1141.5,413.999918 C1141.5,413.585185 1141.83604,413.249966 1142.24993,413.249966 C1142.66397,413.249966 1143,413.585185 1143,413.999918 L1143,416.249911 C1143,416.664643 1142.66397,417 1142.24993,417 Z" />
			</g>
		</CustomSVGIcon>
	);
};

Sum.propTypes = {
	color: PropTypes.string,
};

export default Sum;
